module.exports = __webpack_public_path__ + "static/media/pic_parternedBusiness_2.af0ea356.jpg";